module.exports = __webpack_public_path__ + "img/source05_7.3142c47f.png";